import GenericTableResponse from "@/models/api/GenericTableResponse";
import { Expose, Type } from "class-transformer";
import { IsNumber, IsString, ValidateNested } from "class-validator";

export class GetNotSettledDocument {
  @Expose()
  @IsString()
  contractorName!: string; // "Telewizja Polska S.A.";
  @Expose()
  @IsString()
  currency!: string; // "PLN";
  @Expose()
  @IsNumber()
  documentAmount!: number; //1280.85;
  @Expose()
  @IsString()
  documentId!: string; // "00ac6738-0028-421a-8d28-c0e75ced45e3";
  @Expose()
  @IsString()
  documentNumber!: string; // "2921/02/2022/RZE";
  @Expose()
  @IsString()
  issueDate!: string; // "2022-02-17";
  @Expose()
  @IsNumber()
  leftToPay!: number; // 1280.85;
}

export class GetNotSettledDocumentsResponse extends GenericTableResponse<GetNotSettledDocument> {
  @Type(() => GetNotSettledDocument)
  @ValidateNested()
  @Expose()
  // eslint-disable-next-line
  // @ts-ignore
  items!: Array<GetNotSettledDocument>;
}
